import React, { useId } from 'react';
export type LogoColor = 'purple' | 'black' | 'maroon';
type LogoProps = {
  className?: string;
  color?: LogoColor;
};
export const logoUrl = 'https://cdn.magicpatterns.com/uploads/5bq7fuc6XZZuick6QoriqR/logo.png';

// Target ink color (0–1 RGB) the dark artwork is remapped to. White outline stays white.
const tints: Record<Exclude<LogoColor, 'purple'>, [number, number, number]> = {
  black: [0.1, 0.1, 0.11],
  maroon: [0.478, 0.094, 0.149]
};
export function Logo({
  className = 'h-14 w-auto',
  color = 'purple'
}: LogoProps) {
  const filterId = `logo-tint-${useId().replace(/[^a-zA-Z0-9_-]/g, '')}`;
  const tint = color === 'purple' ? null : tints[color];
  return <>
      {tint && <svg aria-hidden="true" width="0" height="0" className="absolute" data-id="element-185" data-mp="hsgh4l5d8leq">
          <filter id={filterId} colorInterpolationFilters="sRGB" data-id="element-186" data-mp="2yhvplked7es1">
            <feColorMatrix type="saturate" values="0" data-id="element-187" data-mp="2ykrmd5eh7xew" />
            <feComponentTransfer data-id="element-188" data-mp="32ks2cuh84go2">
              <feFuncR type="table" tableValues={`${tint[0]} ${tint[0]} 1`} data-id="element-189" data-mp="32hw6dboxs229" />
              <feFuncG type="table" tableValues={`${tint[1]} ${tint[1]} 1`} data-id="element-190" data-mp="1evjgn1ycc56g" />
              <feFuncB type="table" tableValues={`${tint[2]} ${tint[2]} 1`} data-id="element-191" data-mp="19wyh74qwxpj2" />
            </feComponentTransfer>
          </filter>
        </svg>}
      <img src={logoUrl} alt="Helena Body & Paint, Inc." className={className} style={tint ? {
      filter: `url(#${filterId})`
    } : undefined} data-id="element-192" data-mp="1ntd3lma7tmgy" />
    </>;
}